import React from 'react';

interface ERupiVoucherHeaderProps {}

const ERupiVoucherHeader: React.FC<ERupiVoucherHeaderProps> = () => {
  return (
    <div className="flex border-b border-cardborder mb-8 flex-col md:flex-row md:items-center md:justify-between max-w-7xl mx-auto px-7 py-8">
      <div className="flex items-center h-10">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold text-gray-900">
            Search Voucher 
          </h1>
        </div>
      </div>
    </div>
  );
};

export default ERupiVoucherHeader;

